import styled from 'styled-components';
import {
  Box, Button, DataTable, Text, Anchor, Table, TableRow,
} from 'grommet';

const StyledPagedTable = styled(DataTable)`
  th {
    border-bottom: 1px solid var(--page-table-border);
    background-color: var(--page-table-bg);
  }
`;

const StyledPagedTableRowLabel = styled(Text)`
  * { font-weight: inherit; }
`;

const StyledPagedTableUrl = styled(Anchor)`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow:hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;

  &:hover { text-decoration: underline; }

  @media (max-width: 48em) {
    -webkit-line-clamp: 3;
  }
`;

const StyledExtraUrlContainer = styled(Box)`
  span {
    word-break: keep-all;
    text-wrap: nowrap;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--button-table-text);
  }

  a {
    font-size: 0.8rem;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow:hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;

    &:hover { text-decoration: underline; }

    @media (max-width: 768px) {
      -webkit-line-clamp: 2;
    }
  }

  @media (max-width: 768px) {
    > div {
      flex-direction: column;
      align-items: start;
    }

    span, a { font-size: 0.95rem; }
  }
`;

const StyledDetailTable = styled(Table)`
  th { border-bottom: 1px solid var(--page-table-border); }
`;

const StyledDetailTableRow = styled(TableRow)`
  background-color: ${({ rowColor }) => rowColor};
  border-bottom: 1px solid var(--page-table-border);

  @media (max-width: 768px) {
    border-bottom: ${({ isLast }) => (isLast ? '1px solid var(--page-table-border)' : 'none')};
  }
`;

const StyledDropMenu = styled(Button)`
  padding: 0.5rem 0.45rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: var(--app-radius);
  color: ${({ textColor }) => textColor};

  &:hover {
    color: ${({ hoverTextColor }) => hoverTextColor};
  }

  @media (max-width: 768px) {
    padding: 0.75rem 0.45rem;
  }
`;

const StyledDetailDropMenu = styled(Box)`
  padding: 0.25rem 0.45rem;
  font-size: 0.9rem;
  cursor: default;
  letter-spacing: normal;
  overflow: auto;
  white-space: pre-line;
  color: var(--page-url-color);
  font-weight: 600;
`;

const StyledExtraUrlButton = styled(Box)`
  text-align: start;
  background-color: var(--button-table-bg);
  border-radius: var(--app-radius);
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--button-table-text);

  @media (max-width: 768px) {
    padding: 0.35rem 0.6rem;
    font-size: 0.8rem;
  }
`;

export {
  StyledPagedTable,
  StyledPagedTableRowLabel,
  StyledPagedTableUrl,
  StyledDetailTable,
  StyledDetailTableRow,
  StyledDropMenu,
  StyledDetailDropMenu,
  StyledExtraUrlContainer,
  StyledExtraUrlButton,
};
